import script from "./WhoWeAre.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&setup=true&lang=js"

import "./WhoWeAre.vue?vue&type=style&index=0&id=9afd2766&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9afd2766"]])

export default __exports__